/**
 * This code closely follows https://github.com/ngs/draft-js-markdown-shortcuts-plugin.
 * This is more customised to Milanote's use case.
 */

// Utils
import handleBeforeInput from './handleBeforeInput';
import handleReturn from './handleReturn';
import customStyleMap from './customStyleMap';

export default ({ enableBlockStyles }) => ({
    handleBeforeInput: handleBeforeInput({ enableBlockStyles }),
    handleReturn: handleReturn({ enableBlockStyles }),
    customStyleMap,
});
